import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

export const updateVideoOnboarding = async ({ cityId, additionalInfo }) => {
  const query = `mutation createOrUpdateVideoOnboardingCityAdditionalInfo(
    $input: CreateOrUpdateVideoOnboardingCityAdditionalInfoInput!
  ) {
    createOrUpdateVideoOnboardingCityAdditionalInfo(
      input: $input
    ) { 
      success
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, {
    input: {
      cityId,
      additionalInfo,
    },
  })
}

export const getAdditionalInfo = ({ id }) => {
  const query = `query getCity($id: ID!){
    city(id:$id){
      id
      videoOnboardingCityAdditionalInfo
   }
}`
  return callAuthorizedGraphQLEndpoint(query, {
    id,
  })
}
